/* eslint @typescript-eslint/camelcase: 0 */
import { request } from "api";

export type CreateParams = {
  agencyId?: number;
  appGroupId?: number;
  apps?: {
    id?: number;
    redDmpAppId?: number;
  }[];
  redUserId?: number;
  isTver?: boolean;
  twitterUserId?: string;
};

export class Api {
  public static create(params: CreateParams) {
    return request.post("/admin/agency_apps", params);
  }
}
